import { TabNames } from '@enums/TabNames';
import { CustomCellSalespersonComponent } from '@shared/grids/custom-cell-salesperson/custom-cell-salesperson.component';
import { ColDef, ICellRendererParams } from 'ag-grid-enterprise';

export const ACCOUNTS_GRID_COLUMNS: ColDef[] = [
    {
        colId: 'id',
        field: 'id',
        headerName: 'ID',
        width: 100,
        lockPinned: true,
        lockPosition: 'left',
        suppressSizeToFit: true,
        cellRenderer: (params: ICellRendererParams) => {
            if (params.value) {
                const link = `/accounts-single/${params.value}/${TabNames[TabNames.Overview]}`;
                return `<a class="anchor" href="${link}">${params.value}</a>`;
            }
            return '';
        }
    },
    {
        colId: 'name',
        field: 'name',
        headerName: 'Name',
        cellDataType: 'text',
        cellEditor: 'agTextCellEditor'
    },
    {
        colId: 'accountTypeName',
        field: 'accountTypeName',
        headerName: 'Type',
        cellDataType: 'text',
        cellEditor: 'agTextCellEditor'
    },
    {
        colId: 'markets',
        field: 'markets',
        headerName: 'Markets',
        cellDataType: 'text',
        cellEditor: 'agTextCellEditor'
    },
    {
        colId: 'accountSalespersons',
        field: 'accountSalespersons',
        headerName: 'Salesperson',
        cellRenderer: CustomCellSalespersonComponent
    },
    {
        colId: 'isActive',
        field: 'isActive',
        headerName: 'Condition',
        valueFormatter: (params: any) => {
            return params.value ? 'Active' : 'Archived';
        }
    }
];
